window.addEventListener("load", function () {
     window.scrollReveal = new scrollReveal({ reset: true, move: '20px' });


     document.documentElement.addEventListener("click", function (e) {
        if (document.querySelector(".facet-sort-by-pc")) {
            let open_sort_by = Boolean(document.querySelector(".facet-sort-by-pc").getAttribute("aria-expanded") == "true");
            if (!e.target.closest(".facet-sort-by-pc") && open_sort_by) {
                document.querySelector(".facet-sort-by-pc").querySelector("summary").click();
            }
        }
        
     })
    // let _currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });
    let _currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: "USD" });

    $(".custom-sub-product-quantity").blur(function () {
        const $this = $(this);
        const $form = $this.parents("form");
        const $estimatedWrapper = $form.find(".custom-sub-product-estimated-wrapper");
        let price = $this.data("price") * 1;
        const quantity = $this.val();
        const estimatedMethod = $form.find(".custom-sub-product-estimated-input").val();
        const max = $this.data("max") * 1;
        const drawer = $form.find(`#${$this.data("drawerid")}`)
        const status = drawer.find(".custom-delivery-date-wrapper3").attr("data-status")
        let price_break_config = $this.data("pricebreaks") || null;
        if (price_break_config) {
            let price_break_list = price_break_config.split(",");
            for (let price_break of price_break_list) {
                let price_break_quantity= Number(price_break.split("-")[0]);
                let price_break_price = Number(price_break.split("-")[1]);
                if (quantity >= price_break_quantity) {
                    price = price_break_price;
                    $form.find(".custom-sub-product-price>span").html(_currencyFormatter.format(price / 100));
                    let coe = Number($form.find(".custom-sub-product-price-coe").data("coe"));
                    $form.find(".custom-sub-product-price-coe>span").html(_currencyFormatter.format(price / coe / 100));
                }
            }
        }

        const totalPrice = price * quantity;

        $form.find(".custom-sub-product-price-total").html(_currencyFormatter.format(totalPrice / 100));

        
        if (quantity < 1) {
            $this.val(1);
        }
        if(quantity > max){
            drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-num").html(max)
            if (max > 1) {
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("item")
            }
            drawer.find(".delivery-drawer-preOrder-public").removeClass("d-none")
            drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-num").html(quantity - max)
             if (quantity - max > 1) {
                drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-unit").html("item")
            }
        }else{
            drawer.find(".delivery-drawer-preOrder-public").addClass("d-none")
            drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-num").html(quantity)
            if (quantity > 1) {
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("item")
            }
        }
        if (status != "nomal") {
            drawer.find(".delivery-drawer-test3-inStock").addClass("d-none")
            drawer.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
            drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity)
             if (quantity > 1) {
                drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-unit").html("item")
            }
        }
        drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-num").html(quantity)
        if (quantity > 1) {
            drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-unit").html("items")
        }else{
            drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-unit").html("item")
        }
        const $inStock = $estimatedWrapper.find(".custom-sub-product-estimated-inStock");
        const $preOrder = $estimatedWrapper.find(".custom-sub-product-estimated-preOrder");
        
        if (estimatedMethod == "Ship as Available") {
            if(max <= 0){
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
                  if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            }else if (quantity > max) {
                $inStock.find("button").removeClass("d-none");
                $inStock.removeClass("d-none");
                $inStock.find(".custom-sub-product-estimated-num").html(max);
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity - max);
                if (max > 1) {
                    $inStock.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $inStock.find(".custom-sub-product-estimated-unit").html("item")
                }
                if (quantity - max > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            } else {
                $inStock.find("button").addClass("d-none");
                $inStock.find(".custom-sub-product-estimated-num").html(quantity);
                 if (quantity > 1) {
                    $inStock.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $inStock.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.addClass("d-none");
            }
        } else if(estimatedMethod == "Ship in Full") {
            $inStock.addClass("d-none");
            $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
             if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
            $preOrder.removeClass("d-none");
        }else{
            if(status != "nomal"){
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
                  if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            }else{
                $inStock.removeClass("d-none");
                if (quantity > max) {
                    $inStock.find(".custom-sub-product-estimated-num").html(max);
                    $preOrder.find(".custom-sub-product-estimated-num").html(quantity - max);
                    if (max > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                   if (quantity - max > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                } else {
                    $inStock.find(".custom-sub-product-estimated-num").html(quantity);
                      if (quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.addClass("d-none");
                }
            }
        }
    });
    $(".custom-sub-products-collapse-all").click(function () {
        if ($(this).hasClass("open")) {
            $(this).find("span").text("Expand All")
            $(this).removeClass("open")
            $(this).parents(".custom-sub-products-section").find("details").each((index, element) => {
                if ($(element).attr("aria-expanded") == 'true') {
                    $(element).find("summary").click()
                }
            });
        }else{
            $(this).find("span").text("Collapse All")
            $(this).addClass("open")
            $(this).parents(".custom-sub-products-section").find("details").each((index, element) => {
                if ($(element).attr("aria-expanded") == 'false') {
                    $(element).find("summary").click()
                }
            });
        }
    })
    
    $(".delivery-method-drawer-content").find("button[type='submit']").click(function () {
        const $this = $(this);
        const $drawerRadios = $this.siblings(".delivery-method-radio");
        const input_target = $drawerRadios.find(".estimated-radio").data("input");
        const $form = $(`#${input_target}`).parents("form")
        const val = $drawerRadios.find(".estimated-radio:checked").val();
        const diffDays =$(".custom-sub-products-section").data("diffdate") * 1
        const estimatedMethod = $form.find(".custom-sub-product-estimated-input").val();
        const currentDate = new Date();
        const targetDate = new Date();
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        $this.attr("aria-busy", "true");
        setTimeout(() => {
            $(`#${input_target}`).val(val);
            // const target = new Date(2026, 3, 20);
            // const today = new Date();
            // today.setHours(0, 0, 0, 0);
            // const new_diffMs = target - today; 
            // const new_diffDays = Math.ceil(new_diffMs / (1000 * 60 * 60 * 24));
            const new_diffDays = "50";
            if (val == "Delivery") {
                targetDate.setDate(currentDate.getDate() + diffDays);
                const formattedDate = targetDate.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
                $form.find(".custom-delivery-method").text("delivery")
                $form.find(".custom-estimated-inStock-date").text(formattedDate)
                $form.find(".custom-sub-product-method-value").text(val)
                if(estimatedMethod == "Ship as Available"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays);
                } else if (estimatedMethod == "Ship in Full"){
                	$form.find(".custom-subProduct-diffDays").val(new_diffDays);
                }
            }else{
                targetDate.setDate(currentDate.getDate() + diffDays - 1);
                const formattedDate = targetDate.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
                $form.find(".custom-delivery-method").text("pickup")
                $form.find(".custom-estimated-inStock-date").text(formattedDate)
                $form.find(".custom-sub-product-method-value").text(val)
                if(estimatedMethod == "Ship as Available"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays - 1);
                } else if (estimatedMethod == "Ship in Full"){
                	$form.find(".custom-subProduct-diffDays").val(new_diffDays);
                }
            }
            $this.siblings(".estimated-close").click();
            $this.removeAttr("aria-busy");
        }, 800);
    })
    $(".delivery-drawer-content").find("button[type='submit']").click(function () {
        const $this = $(this);
        const $drawerRadios = $this.siblings(".delivery-drawer-radios");
        const $customDeliveryQuantity = $this.siblings(".custom-delivery-quantity");
        const input_target = $drawerRadios.find(".estimated-radio").data("input");
        const $form = $(`#${input_target}`).parents("form")
        const method = $form.find(".custom-sub-product-method").val();
        const val = $drawerRadios.find(".estimated-radio:checked").val();
        const diffDays =$this.data("diffdate") * 1
        const max_quantity = $customDeliveryQuantity.data("inven") * 1;
        const target_input = $customDeliveryQuantity.data("id");
        const current_quantity = $(`#${target_input}`).val();
        const status = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-status")
        const $inStock = $form.find(".custom-sub-product-estimated-inStock");
        const $preOrder = $form.find(".custom-sub-product-estimated-preOrder");
        $this.attr("aria-busy", "true");
        setTimeout(() => {
            $(`#${input_target}`).val(val);
            if (val === 'Ship as Available') {
                $inStock.removeClass("d-none");
                $inStock.find(".custom-sub-product-estimated-date").html($drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-default"));
                if (current_quantity > max_quantity) {
                    $inStock.find(".custom-sub-product-estimated-num").html(max_quantity);
                    $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity - max_quantity);
                    if (max_quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    if (current_quantity - max_quantity > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                } else {
                    $inStock.find(".custom-sub-product-estimated-num").html(current_quantity);
                      if (current_quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.addClass("d-none");
                }
                if(method == "Delivery"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays);
                }else if(method == "Pick Up"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays - 1);
                }
            } else if (val === 'Ship in Full') {
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity);
                if (current_quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
                // const target = new Date(2026, 3, 20);
                // const today = new Date();
                // today.setHours(0, 0, 0, 0);
                // const new_diffMs = target - today; 
                // const new_diffDays = Math.ceil(new_diffMs / (1000 * 60 * 60 * 24));
                // $form.find(".custom-subProduct-diffDays").val(new_diffDays);
                $form.find(".custom-subProduct-diffDays").val("50");
            } else {
                let instockDate = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-stock")
                let preOrderDate = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-preorder")
                if(status != "nomal"){
                    $inStock.addClass("d-none");
                    $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity);
                    if (current_quantity > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                    $preOrder.find(".custom-sub-product-estimated-date").text(preOrderDate)
                }else{
                    if (instockDate != "") {
                        $inStock.find(".custom-sub-product-estimated-date").html(instockDate);
                    }
                    if (preOrderDate != "") {
                        $preOrder.find(".custom-sub-product-estimated-date").html(preOrderDate);
                    }
                    $inStock.removeClass("d-none");
                    if (current_quantity > max_quantity) {
                        $inStock.find(".custom-sub-product-estimated-num").html(max_quantity);
                        $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity - max_quantity);
                        if (max_quantity > 1) {
                            $inStock.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $inStock.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        if (current_quantity - max_quantity > 1) {
                            $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        $preOrder.removeClass("d-none");
                    } else {
                        $inStock.find(".custom-sub-product-estimated-num").html(current_quantity);
                        if (current_quantity > 1) {
                            $inStock.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $inStock.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        $preOrder.addClass("d-none");
                    }
                }
            }
            $this.siblings(".estimated-close").click();
            $this.removeAttr("aria-busy");
        }, 800);
    });
    $(".sample_fieldset").find("select").change(function () {
        let $form = $(this).parents("form");
        let price = $(this).find("option:selected").data("price");
        let max = $(this).find("option:selected").data("max");
        let current_sku = $(this).find("option:selected").data("sku");
        let quantity = $form.find(".sample_quantity").val();
        $form.find(".sample_total_price").html(_currencyFormatter.format((price * quantity) / 100));
        $form.find(".sample_quantity").attr("max", max);
        $form.find(".sample_quantity").attr("data-sku", current_sku);
        $form.find(".sample_quantity_error").find("span").html(max);
        $form.find(".sample_quantity_free_tip").find("span").html(max);

        if (quantity > max) {
            $form.find(".sample_quantity_error").fadeIn();
            $form.find(".sample_product_button").find("button:not(._disabled)").attr("disabled", true);
        }else{
            $form.find(".sample_quantity_error").fadeOut();
            $form.find(".sample_product_button").find("button:not(._disabled)").removeAttr("disabled");
        }
        if(price == 0){
            $form.find(".sample_quantity_free_tip").show();
        }else{
            $form.find(".sample_quantity_free_tip").hide();
        }
    });
    $(".sample_fieldset").find(".sample_quantity").change(function () {
        let $form = $(this).parents("form");
        let price = $form.find("select").find("option:selected").data("price");
        let max = $(this).attr("max") * 1;
        let quantity = $(this).val() * 1;
        $form.find(".sample_total_price").html(_currencyFormatter.format((price * quantity) / 100));
        if (quantity > max) {
            $form.find(".sample_quantity_error").fadeIn();
            $form.find(".sample_product_button").find("button:not(._disabled)").attr("disabled", true);
        }else{
            $form.find(".sample_quantity_error").fadeOut();
            $form.find(".sample_product_button").find("button:not(._disabled)").removeAttr("disabled");
        }
    });

    // custom-register
    $("#custom-register-another-checkbox").change(function () {
        const $this = $(this);
        const $form = $this.parents("form");
        if ($this.is(":checked")) {
            $form.find(".custom-register-another-address").removeClass("d-none");
        } else {
            $form.find(".custom-register-another-address").addClass("d-none");
        }
    })
    
})

function custom_click(id,max,in_stock_day,pre_order_day) {
    const date = new Date();
    const current_year = date.getFullYear();
    const current_month = String(date.getMonth() + 1).padStart(2, '0');
    const current_day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${current_year}-${current_month}-${current_day}`;
    window.open_date = true
    jeDate(`#${id}`, {
        trigger: false,
        minDate: formattedDate,
        format: 'YYYY-MM-DD',
        onClose: false,
        isClear: false,
        isToday: false,
        isYes: false,
        donefun:function(a){
            let selected_date = new Date(a.val)
            let in_stock_date = new Date(in_stock_day)
            let pre_order_date = new Date(pre_order_day)
            let $box = $(a.elem).parents(".delivery-drawer-radios")
            const quantity = $box.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-num").html() * 1
            let max_quantity = max * 1
            const selected_day = selected_date.getDate();
            const selected_month = selected_date.toLocaleString('en-us', { month: 'short' }); 
            const selected_year = selected_date.getFullYear();
            const selected_date_format = `${selected_day} ${selected_month} ${selected_year}`
            const preOrder_day = pre_order_date.getDate();
            const preOrder_month = pre_order_date.toLocaleString('en-us', { month: 'short' }); 
            const preOrder_year = pre_order_date.getFullYear();
            const preOrder_date_format = `${preOrder_day} ${preOrder_month} ${preOrder_year}`
            
            const default_date_format = $box.find(".custom-delivery-date-wrapper3").attr("data-default")
            if (selected_date <= in_stock_date) {
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock", default_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",preOrder_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'nomal')
                $box.find(".delivery-drawer-test3-inStock").removeClass("d-none")
                $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-date").text(default_date_format)
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(preOrder_date_format)
                if(quantity > max_quantity ){
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(max_quantity)
                    $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                    $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity - max_quantity)
                }else{
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(quantity)
                    $box.find(".delivery-drawer-test3-preOrder").addClass("d-none")
                }
            }else if(selected_date > in_stock_date && selected_date <= pre_order_date){
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock",selected_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",preOrder_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'nomal')
                $box.find(".delivery-drawer-test3-inStock").removeClass("d-none")
                $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-date").text(selected_date_format)
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(preOrder_date_format)
                if(quantity > max_quantity ){
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(max_quantity)
                    $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                    $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity - max_quantity)
                }else{
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(quantity)
                    $box.find(".delivery-drawer-test3-preOrder").addClass("d-none")
                }
            }else{
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock","")
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",selected_date_format)
                $box.find(".delivery-drawer-test3-inStock").addClass("d-none")
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity)
                $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(selected_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'timeOut')
            }
        }
    })
}




class customIntroduceColl extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".custom-introduce-coll-icon")
    this.wrapper = this.querySelector(".custom-introduce-coll-content")
  }
connectedCallback() {
    if (!this.button || !this.wrapper) return;
    
    this.button.addEventListener("click", () => {
      this.toggle();
    });
  }
    toggle() {
        const isOpen = this.classList.contains("open");
        console.log(this);

        if (isOpen) {
            $(this.wrapper).slideUp()
        this.classList.remove("open");
        } else {
            $(this.wrapper).slideDown()
        this.classList.add("open");
        }
    }
}
if (!window.customElements.get("custom-introduce-coll")) {
customElements.define('custom-introduce-coll', customIntroduceColl);
}
class customJeDate extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input")
  }
connectedCallback() {
    this.addEventListener("click", () => {
      this.toggle();
    });
  }
    toggle() {
        const date = new Date();
        const current_year = date.getFullYear();
        const current_month = String(date.getMonth() + 1).padStart(2, '0');
        const current_day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${current_year}-${current_month}-${current_day}`;
        window.open_date = true
        jeDate(this.input, {
            trigger: false,
            minDate: formattedDate,
            format: 'YYYY-MM-DD',
            onClose: false,
            isClear: false,
            isToday: false,
            isYes: false,
            disabledDate:["2026/9/25","2026/11/3","2026/12/19", "2026/12/20", "2026/12/21", "2026/12/22", "2026/12/23","2026/12/24", "2026/12/25", "2026/12/26", "2026/12/27", "2026/12/28",  "2026/12/29", "2026/12/30", "2026/12/31", "2027/1/1",  "2027/1/2", "2027/1/3", "2027/1/4","2027/1/5", "2027/1/6","2027/1/7","2027/1/8","2027/1/9","2027/1/10","2027/1/26","2027/3/8","2027/3/26","2027/3/27","2027/3/28","2027/3/29","2027/4/25","2027/6/14","2027/9/24","2027/11/2"],
            donefun:function(a){
                console.log(a)
            }
        })
    }
}
if (!window.customElements.get("custom-je-date")) {
    customElements.define('custom-je-date', customJeDate);
}


class customInputRequired extends HTMLElement {
  constructor() {
    super();
    this.input = null

  }
connectedCallback() {
    this.input = this.querySelector("input") || this.querySelector("textarea")
    if (!this.input) return;
    const defaultMsg = this.getAttribute('data-message') || 'Please fill out this field.'
    this.handleInvalid = (e) => {
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity(defaultMsg);
      }
    };
    this.handleInput = (e) => {
      e.target.setCustomValidity('');
    };
    this.input.addEventListener('invalid', this.handleInvalid);
    this.input.addEventListener('input', this.handleInput);
  }
  disconnectedCallback() {
    if (this.input) {
      this.input.removeEventListener('invalid', this.handleInvalid);
      this.input.removeEventListener('input', this.handleInput);
    }
  }
}
if (!window.customElements.get("custom-input-required")) {
customElements.define('custom-input-required', customInputRequired);
}